import React from 'react';
import { ACTION_BAR_BOTTOM_CLASS } from '../lib/bottomNavMetrics';

// La barra de acción vive JUSTO encima del nav: nunca lo tapa y nunca queda
// bajo el home indicator. El alto del nav ya NO se escribe aquí — es un solo
// número en lib/bottomNavMetrics.js, que en la app vale la huella de la
// píldora y en web sigue valiendo los 3.5rem de la barra pegada. Se re-exporta
// para no cambiarle la superficie pública a este módulo.
export { ACTION_BAR_BOTTOM_CLASS };

// Clearance que el contenido scrolleable reserva en mobile para que nada quede
// oculto tras la barra fija (la barra mide ~64-88px según su contenido).
export const ACTION_BAR_CLEARANCE_CLASS = 'pb-24 md:pb-0';

/**
 * Barra de acción fija al fondo (patrón WhatsApp) — UNA sola implementación
 * compartida por el Study Center y las sesiones de estudio (F4.3c).
 *
 * En mobile (<md) es una barra fija encima del bottom nav. En desktop (md+):
 *  - inlineOnDesktop=false (Study Center): la barra desaparece — el desktop ya
 *    cabe sin scroll y conserva su CTA original dentro de la card de ajustes.
 *  - inlineOnDesktop=true (sesiones): el MISMO nodo se vuelve estático y sin
 *    estilos de barra, de modo que desktop queda visualmente idéntico a antes
 *    y los botones de acción no se duplican en el DOM (cero testids repetidos).
 *
 * Flashcards NO usa esta barra: su interacción es flip/conocida/aprendiendo con
 * controles propios centrados, no un botón de avance que el contenido desplaza.
 */
/* ── TANDA 21 (#212) — DE QUÉ CUELGA LA BARRA ────────────────────────────────
 *
 * `viewport` (el de siempre, y el default): anclada a la pantalla. Es lo que
 * necesitan las dos pantallas de SESIÓN —AdaptiveStudy y ExamSimulator—, que
 * viven fuera del carril y no tienen ninguna caja a la que agarrarse: para
 * ellas, esto no cambia ni un carácter.
 *
 * `mueble`: anclada a la CAJA DE SU PÁGINA. La estrena el Centro de Estudio
 * cuando vive dentro del carril, y es lo que hace que el recuadro entre
 * deslizando con su hoja en vez de estar clavado a la pantalla — la firma #212.
 * Quien la pide tiene que montarla dentro de un ancestro posicionado que sea la
 * caja de la página (el marco de la pane); sin él, `absolute` treparía hasta el
 * primer ancestro posicionado que encuentre, que no es lo que nadie quiere.
 *
 * LA ÚNICA DIFERENCIA ES LA PALABRA DEL ANCLAJE. Ni el z, ni el `calc` del
 * fondo, ni el borde, ni el vidrio, ni los paddings, ni el `md:` cambian: lo
 * demás de este archivo se queda como estaba, carácter por carácter. */
export const ANCLAJE = { VIEWPORT: 'viewport', MUEBLE: 'mueble' };

export default function SessionActionBar({
  children,
  inlineOnDesktop = false,
  desktopClassName = '',
  testid = 'session-action-bar',
  anclaje = ANCLAJE.VIEWPORT,
}) {
  const posicion = anclaje === ANCLAJE.MUEBLE ? 'absolute left-0 right-0' : 'fixed left-0 right-0';
  const mobileBar = `${posicion} z-40 ${ACTION_BAR_BOTTOM_CLASS} border-t border-[#262626] bg-[#0e0e0e]/95 backdrop-blur-xl px-3 pt-2.5 pb-2.5`;
  const desktop = inlineOnDesktop
    ? `md:static md:z-auto md:border-t-0 md:bg-transparent md:backdrop-blur-none md:px-0 md:pt-0 md:pb-0 ${desktopClassName}`
    : 'md:hidden';
  return (
    <div className={`${mobileBar} ${desktop}`} data-testid={testid}>
      {children}
    </div>
  );
}
